<template>
  <ul class="c-list c-list--results">
    <li 
      class="c-list__item"
      v-for="(item, i) in resultsListing"
      v-bind:key="i">
      <component 
        v-if="item"
        :is="itemComponent"
        :item="item"
        :siteUrl="siteUrl"
        v-on:resultClick="searchResultsItemClick">
      </component>
    </li>
  </ul>
</template>

<script>
import SearchItemDoc from "./SearchItemDoc.vue";
import SearchItemPage from "./SearchItemPage.vue";

export default {
  name: "SearchListing",
  components: {
    SearchItemDoc,
    SearchItemPage
  },
  props: {
    itemComponent: {
      type: String
    },
    resultsListing: {
      type: Array
    },
     siteUrl: {
      type: String
    }
  },
  methods: {
    searchResultsItemClick(searchType, objectId, position) {
      this.$emit('searchResultClick', searchType, objectId, position);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/reportAProblem/results/SearchListing.vue